"use client";

import { useTranslations } from "next-intl";
import { usePopularShops } from "@/hooks/queries";
import { useRecentlyViewedShops } from "@/contexts/recently-viewed-context";
import { HorizontalScrollRow } from "@/components/horizontal-scroll-row";
import { ScrollTile } from "@/components/scroll-tile";
import { TileSection } from "@/components/sections/tile-section";
import { SCROLL_TILE_WIDTH } from "@/lib/constants";

export function ImpactShopsSection() {
  const t = useTranslations("impact");
  const tProjects = useTranslations("projects");
  const { recentShops, isLoading: recentLoading } = useRecentlyViewedShops();
  const { data: popularData, isLoading: popularLoading } = usePopularShops({ size: 12 });

  const hasRecent = recentShops.length > 0;
  const shops = hasRecent ? recentShops : (popularData?.content ?? []);
  const isLoading = recentLoading || (!hasRecent && popularLoading);
  const title = hasRecent ? t("recentlyViewedShops") : tProjects("detail.supportViaShopping");

  return (
    <TileSection
      title={title}
      isLoading={isLoading}
      isEmpty={shops.length === 0}
      seeAllHref="/shops"
      seeAllLabel={tProjects("detail.allShops")}
    >
      <HorizontalScrollRow>
        {shops.map((shop) => (
          <div key={shop.id} className={`shrink-0 ${SCROLL_TILE_WIDTH}`}>
            <ScrollTile
              href={`/shops/${shop.slug}`}
              name={shop.name ?? ""}
              logoUrl={shop.logoUrl}
              shopId={shop.id}
              commissionRangeSummary={shop.commissionRangeSummary}
            />
          </div>
        ))}
      </HorizontalScrollRow>
    </TileSection>
  );
}
